import 'babel-polyfill';
import 'dom4';
import 'whatwg-fetch'

if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}


// WEBPACK FOOTER //
// ./assets/js/polyfills.js